import React, { useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // 1. Import useLocation
import { ThemeContext } from '../../context/ThemeContext';
import SideMenu from './header/SideMenu';
import ThemeSwitcher from './header/ThemeSwitcher';
import PageLinks from './header/PageLinks';
import HamburgerMenu from './header/HamburgerMenu';
import CodesiosLogo from './header/CodesiosLogo';

const Header = () => {
    const { theme, changeTheme, themes, particleOptions, particleOption } = useContext(ThemeContext);
    const [menuOpen, setMenuOpen] = useState(false);
    
    // 2. Get current path and theme lightness
    const location = useLocation();
    const isHome = location.pathname === '/';
    const isLight = themes[theme]?.isIconDark;

    useEffect(() => {
        const previousOverflow = document.body.style.overflow;
        if (menuOpen) document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = previousOverflow;
        };
    }, [menuOpen]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setMenuOpen(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // 3. Define adaptive transparency classes based on the page:
    // - Home: Maximum transparency (bg-transparent or light tint with subtle blur)
    // - Other Pages: Slightly deeper frosted tint with stronger blur for clean scrolling
    const headerGlassClasses = isHome
        ? 'bg-transparent backdrop-blur-sm'
        : isLight
            ? 'bg-white/40 backdrop-blur-md'
            : 'bg-black/35 backdrop-blur-md';

    return (
        <>
            <header
                className={`sticky top-0 z-40 p-4 transition-all duration-300 ${headerGlassClasses} ${themes[theme].text}`}
                style={{ 
                    borderBottom: `2px solid ${themes[theme].borderColor || '#ffffff'}` 
                }}
            >
                <nav className="container mx-auto flex justify-between items-center relative">
                    {/* Left-aligned element */}
                    <CodesiosLogo />

                    {/* Center-aligned element */}
                    <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2">
                        <PageLinks />
                    </div>

                    {/* Right-aligned elements */}
                    <div className="flex space-x-4 items-center">
                        <ThemeSwitcher
                            themes={themes}
                            theme={theme}
                            changeTheme={changeTheme}
                            particleOptions={particleOptions}
                            particleOption={particleOption}
                        />
                        <HamburgerMenu menuOpen={menuOpen} setMenuOpen={setMenuOpen} controlsId="mobile-menu" />
                    </div>
                </nav>
            </header>

            {/* Kept outside header so mobile drawer is never clipped */}
            <SideMenu
                menuOpen={menuOpen}
                setMenuOpen={setMenuOpen}
                themes={themes}
                changeTheme={changeTheme}
                particleOptions={particleOptions}
                particleOption={particleOption}
            />
        </>
    );
};

export default Header;
